// extracted by mini-css-extract-plugin
export default {"button":"CreateButton_button__wjHhr"};